const Resources = {

    table_headers: [
        { 
            text:  'Name',
            align: 'start',
            value: 'name',
            event: true,
        },
        { 
            text:   'Step',
            value:  'code'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Step Codes',
            href:   '/options-step-codes',
            arrow:  "",
        },
    ],

    excel_file_headers: {
        'Name': 'name',
        'Step': 'code',
        'Memo': 'memo'
    },

    excel_fields_required: {
        name: true,
        code: true,
    },

    empty_format_data: [
        {
            name: '',
            code: '',
        },
    ],

}

export default Resources;